import { IconProps } from '@phosphor-icons/react';

export const DrawingIcon = ({ size = 16, height, color = 'currentColor', ...rest }: IconProps) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.83008 9C7.27808 3.61455 9.52462 1.52055 10.8443 2.92411C12.7203 4.91916 3.0847 10.9743 5.75041 12.5117C7.97148 13.7917 11.5558 6.8082 13.0278 8.59933C13.8962 9.6548 10.8443 11.9942 11.6568 13.1582C12.2141 13.9564 13.4082 13.1958 14.1639 12.5143"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
